<template>
    <div class="lang">
        <div class="greeting">
            <div class="greeting__inner">
                <div class="greeting__bg"><img src="/resource/img/about-bg02.png" alt=""></div>
                <div class="greeting__tit pc-none">
                    <div class="greeting__tit-inner item1">
                        <div>
                            Greetings to all, <br>
                            We would like to give a warm welcome to the Wellness Health Promotion Center.
                        </div>
                    </div>
                </div>
                <div class="greeting__img">
                    <div class="greeting__img-inner">
                        <img src="/resource/img/img_hos01_01.jpg" alt="">
                    </div>
                    <div class="greeting__img-bg"></div>
                </div>
                <div class="greeting__text">
                    <div class="greeting__tit mo-none">
                        <div class="greeting__tit-inner item1">
                            <div>
                                Greetings to all, <br>
                                We would like to give a warm welcome to the Wellness Health Promotion Center.
                            </div>
                        </div>
                    </div>
                    <div class="desc">
                        <p>
                            Since opening Ewha Womans University Mokdong Hospital, Ewha Womans Health Care Center / Health Promotion Center has been loved as a health care partner by establishing a women-friendly and comfortable medical environment with a quick and convenient health Check-up system and one-stop service that allows immediate medical treatment if necessary. In addition, with the opening of Ewha Womans University Seoul Hospital in 2019, the Wellness Health Promotion Center begins as a companion to keep your happiness and healthy life with the goal of wellness, which means well-being and fitness.
                        </p>
    
                        <p>
                            From April 1, 2020, Health Promotion Center in Ewha Womans University Medical Center will be expanded and integrated into the Wellness Health Promotion Center of Ewha Womans University Seoul Hospital.
                            <br>
                            As a result, Ewha Womans University Medical Center provides the best health check-up service through more sophisticated and convenient facilities as well as more accurate diagnosis, precision medical equipment, a faster and more comfortable medical environment.    
                        </p>
    
                        <p>
                            Ewha Womans University Medical Center's unique women-friendly care environment is specialized in health care that requires more careful attention, which will provide a different health care system not only for women, but also for men, and for people around the world who need advanced Korean medical care.
                        </p>
    
                        <p>
                            The Wellness Health Promotion Center at Ewha Womans University Seoul Hospital will always be with you so that you can stay healthy and get old happily.
                        </p>
    
    
                        <div class="name">
                            <p>Wellness Health Promotion Center, Ewha Womans University Seoul Hospital</p>
                            <span>Hye Kyung Song,  Head of Center</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { gsap, Power1 } from "gsap";
    import { ScrollTrigger } from "gsap/ScrollTrigger";
    gsap.registerPlugin(ScrollTrigger); // 추가된 부분
    export default {
        methods: {
            gsapAbout() {
                gsap.from(".greeting__img img", {
                    height: 0,
                    duration: 1,
                    delay: .5,
                });
                gsap.from(".greeting__img img", {
                    scale: 1.2,
                    duration: 4,
                    delay: 1.4,
                });
                gsap.from(".greeting__img-bg", {
                    opacity: 0,
                    x: 0,
                    y: 0,
                    duration: 1,
                    delay: 1.5,
                });
                gsap.from(".greeting__tit .item2 em span", {
                    width: 0,
                    duration: 1.5,
                    delay: 2,
                    ease: Power1.easeInOut,
                    // onComplete: () => {
                    //     gsap.to(".greeting__tit .item2 em span", {
                    //         backgroundColor: 'var(--aorta-P10)',
                    //         duration: 1.5
                    //     });
                    // }
                });
                gsap.from(".item1 div", {
                    y: '100%',
                    duration: .8,
                    delay: 1.5,
                });
                gsap.from(".item2 div", {
                    y: '100%',
                    duration: .8,
                    delay: 1.5,
                });
                gsap.from(".desc", {
                    opacity: 0,
                    y: 30,
                    duration: 1,
                    delay: 2.8,
                });
                gsap.from(".greeting__bg", {
                    opacity: 0,
                    duration: 3,
                    delay: 1,
                });

            }
        },
        mounted() {
            if (window.innerWidth >= 1025) {
                this.gsapAbout();
            }
        },
    }

</script>
<style>

</style>